// @flow

import styled from '@emotion/styled'
import { Link } from 'gatsby'
import * as React from 'react'

import { colors, media } from '@toggl/style'

import { Logo } from '../logos'
import * as text from '../text'

type JobType = {
  title: string,
  description: string,
  team: 'global' | 'track' | 'hire' | 'plan',
  slug: string,
  ...
}

type Props = {
  title: string,
  jobs: $ReadOnlyArray<JobType>,
}
export const ThreeCol = ({ title, jobs }: Props) => {
  const count = jobs.length
  const summaryText = `${count} position${count === 1 ? '' : 's'}`

  return (
    <Root>
      <HeaderWrapper>
        <text.P2 color={colors.darkPurple60}>{summaryText}</text.P2>
        <text.H4 color={colors.darkPurple90}>{title}</text.H4>
      </HeaderWrapper>

      {jobs.map((vacancy, id) => (
        <VacancyWrapper to={`/jobs/${vacancy.slug}/`} key={id}>
          <VacancyTitleWrapper color={colors.darkPurple100}>
            {' '}
            {vacancy.title}
          </VacancyTitleWrapper>

          <VacancyDescription color={colors.darkPurple80}>
            {vacancy.description}
          </VacancyDescription>

          <TeamStyled>
            <Logo kind={vacancy.team} />
          </TeamStyled>
        </VacancyWrapper>
      ))}
    </Root>
  )
}

const TeamStyled: React.ComponentType<any> = styled.div`
  svg {
    height: 28px;
    fill: ${colors.darkPurple100};
  }
  ${media.mq[2]} {
    flex: 0 0 160px;
    text-align: right;
  }
`

const VacancyDescription: React.ComponentType<any> = styled(text.P3)`
  display: none;
  ${media.mq[2]} {
    display: block;
    flex: 2.5;
    padding-right: 30px;
  }
`

const VacancyTitleWrapper: React.ComponentType<any> = styled(text.P1)`
  ${media.mq[2]} {
    flex: 1;
    padding-right: 30px;
  }
`

const VacancyWrapper: React.ComponentType<any> = styled(Link)`
  display: flex;
  border-radius: 8px;
  flex-direction: column;
  gap: 25px;
  padding: 30px;
  margin: 10px 0;
  background: ${colors.peach100};
  color: ${colors.darkPurple90};
  ${media.mq[1]} {
    margin: 15px 0;
    &:hover {
      background: ${colors.yellow100};
    }
  }
  ${media.mq[2]} {
    flex-direction: row;
    justify-content: space-between;
    padding: 40px;
  }
`

const HeaderWrapper: React.ComponentType<any> = styled.div`
  margin: 25px 0;
`

const Root: React.ComponentType<any> = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 20px auto 0;
`
